import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastModule } from 'primeng/toast';
import { SidebarModule } from 'primeng/sidebar';
import { CalendarModule } from 'primeng/calendar';
import { DialogModule } from 'primeng/dialog';

import { ComponentsModule } from 'src/app/components/components.module';
import { GerinusToolsModule } from 'src/app/app-core/lib/gerinus-tools.module';
import { SecretaryPendingSignaturesComponent } from 'src/app/pages/secretary-pending-signatures/secretary-pending-signatures.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        NgbModule,
        ToastModule,
        SidebarModule,
        CalendarModule,
        DialogModule,
        ComponentsModule,
        GerinusToolsModule,
    ],
    declarations: [SecretaryPendingSignaturesComponent],
    exports: [SecretaryPendingSignaturesComponent],
})
export class SecretaryPendingSignaturesModule {}
